import React from "react"

import * as styles from "./horizontalLine.module.scss"

const HorizontalLine = () => <div className={styles.line}></div>

export default HorizontalLine
